import React from 'react';

interface ReportGadgetsContextType {
  allGadgets: ReportGadgets.ReportGadget[];
  reportGadgetsLookup: {
    [id: string]: ReportGadgets.ReportGadget | undefined;
  };
  isLoading: boolean;
}

const ReportGadgetsContext = React.createContext<ReportGadgetsContextType>({
  allGadgets: [] as ReportGadgets.ReportGadget[],
  reportGadgetsLookup: {},
  isLoading: true,
});

export default ReportGadgetsContext;
